module.exports = __webpack_public_path__ + "img/icon_camera.066366e1.svg";